"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentStatus = void 0;
const ComponentStatus = exports.ComponentStatus = {
  STATUS_DISABLE: 0,
  STATUS_ENABLE: 1
};